import { Component, OnDestroy, OnInit } from '@angular/core'
import { RegistroAcademico } from './registro-academico'
import { RegistroAcademicoService } from './registro-academico.service'
import { LocalStorageService } from 'src/app/shared/services/local-storage.service'
import { MatCardModule } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { UnespCoreAuthService, UnespCoreMessageService } from '@unesp/core'
import { NivelProgramaPipe } from 'src/app/shared/pipes/nivel-programa.pipe'
import { MenuService } from '../menu.service'
import { Subscription } from 'rxjs'
import { Perfil } from '../perfil'
import { getMenuAlunoRegular } from '../../../../menus/menu-aluno-regular'
import { getPerfilByKey } from 'src/app/shared/enums/perfil.enum'
import { menuAlunoEspecial } from 'src/app/menus/menu-aluno-especial'

@Component({
  selector: 'app-registro-academico-selecionar',
  templateUrl: './registro-academico-selecionar.component.html',
  styleUrls: ['./registro-academico-selecionar.component.css'],
  imports: [CommonModule, MatCardModule, MatIconModule, MatButtonModule, NivelProgramaPipe],
})
export class RegistroAcademicoSelecionarComponent implements OnInit, OnDestroy {
  nome: string = ''
  private raSubscription!: Subscription
  ras: RegistroAcademico[] = []
  perfis: Perfil[] = []

  constructor(
    private registroAcademicoService: RegistroAcademicoService,
    private localStorageService: LocalStorageService,
    private unespCoreAuthService: UnespCoreAuthService,
    private menuService: MenuService,
    private unespCoreMessageService: UnespCoreMessageService
  ) {}

  ngOnInit(): void {
    this.nome = this.menuService.getNomeUsuario()
    let idAssEmCache = this.localStorageService.get('idAss')
    this.menuService.perfis$.subscribe(value => {
      this.perfis = value
    })
    this.menuService.isDiscente$.subscribe(value => {
      if (value) {
        let perfilEmCache = this.localStorageService.get('perfil')
        this.raSubscription = this.registroAcademicoService.ras(perfilEmCache).subscribe(data => {
          this.ras = data
          this.ras.sort((a, b) => {
            return a.dataPrimeiraMatricula < b.dataPrimeiraMatricula ? -1 : 1
          })
          if (this.ras.length) {
            this.setSelecaoVerificaCache(this.ras.length - 1, idAssEmCache)
            this.reloadMenu()
          } else {
            // Registra no LOG para conferênia e remove o perfil do usuário (automaticamente)
            if (perfilEmCache != null || perfilEmCache != 'null') {
              this.registroAcademicoService.log(perfilEmCache, this.nome).subscribe()
            }

            this.localStorageService.remove('perfil')
            this.localStorageService.remove('idAss')
            this.localStorageService.remove('identificacaoUsuario')
            this.unespCoreAuthService.logout('Ajustamos alguns dados de acesso. Tente logar novamente.', true)
          }
        })
      } else {
        this.ras = []
      }
    })
  }

  changeSelecao(index: number): void {
    const perfilEmCache = this.localStorageService.get('perfil')
    const identificacaoUsuarioEmCache = this.localStorageService.get('identificacaoUsuario')

    this.localStorageService.set('idAss', this.ras[index].idAss)
    this.localStorageService.set('identificacaoUsuario', {
      nome: this.nome,
      ...this.ras[index],
    })
    this.reloadMenu()
    this.ras.forEach(a => (a.selecionado = false))
    this.ras[index].selecionado = true
    this.notifyUserProfileAndRAChanged(perfilEmCache, identificacaoUsuarioEmCache?.numero, this.ras[index].numero)
  }

  private setSelecaoVerificaCache(index: number, idAssEmCache?: number): void {
    const perfilEmCache = this.localStorageService.get('perfil')
    const identificacaoUsuarioEmCache = this.localStorageService.get('identificacaoUsuario')

    if (idAssEmCache) {
      let found = false
      this.ras.forEach(ra => {
        ra.selecionado = false
        if (ra.idAss === idAssEmCache) {
          ra.selecionado = true
          found = true
          this.localStorageService.set('idAss', ra.idAss)
          this.localStorageService.set('identificacaoUsuario', {
            nome: this.nome,
            ...ra,
          })
          this.notifyUserProfileAndRAChanged(perfilEmCache, identificacaoUsuarioEmCache?.numero, ra.numero)
          return
        }
      })
      if (!found) {
        this.ras[index].selecionado = true
        this.localStorageService.set('idAss', this.ras[index].idAss)
        this.localStorageService.set('identificacaoUsuario', {
          nome: this.nome,
          ...this.ras[index],
        })
        this.notifyUserProfileAndRAChanged(perfilEmCache, identificacaoUsuarioEmCache?.numero, this.ras[index].numero)
      }
    } else {
      this.setSelecao(index)
    }
  }

  private setSelecao(index: number): void {
    const perfilEmCache = this.localStorageService.get('perfil')
    const identificacaoUsuarioEmCache = this.localStorageService.get('identificacaoUsuario')

    this.ras.forEach(a => (a.selecionado = false))
    this.ras[index].selecionado = true
    this.localStorageService.set('idAss', this.ras[index].idAss)
    this.localStorageService.set('identificacaoUsuario', {
      nome: this.nome,
      ...this.ras[index],
    })
    this.notifyUserProfileAndRAChanged(perfilEmCache, identificacaoUsuarioEmCache?.numero, this.ras[index].numero)
  }

  private reloadMenu() {
    const perfilEmCache = this.localStorageService.get('perfil')
    const found = this.perfis.find(p => p.nome === perfilEmCache)
    if (found && 'ALUNO_REGULAR' === perfilEmCache) {
      this.menuService.setItensMenuSource(getMenuAlunoRegular(this.localStorageService.get('identificacaoUsuario')))
    }
    if (found && 'ALUNO_ESPECIAL' === perfilEmCache) {
      this.menuService.setItensMenuSource(menuAlunoEspecial)
    }
  }

  ngOnDestroy() {
    if (this.raSubscription) {
      this.raSubscription.unsubscribe()
    }
  }

  private notifyUserProfileAndRAChanged(perfilEmCache: string, raEmCache: string, ra: string) {
    if (raEmCache !== ra) {
      this.unespCoreMessageService.showMessageSuccess(
        'Registro Acadêmico ' + ra + ' do perfil ' + getPerfilByKey(perfilEmCache) + ' selecionado.'
      )
    }
  }
}
